package com.taocent.simple.compose.component.blockrichtext

import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import com.taocent.simple.compose.component.richtext.core.internal.ui.RichTextTextFieldCore

/**
 * 块级富文本输入框 Composable — 内部委托给 [RichTextTextFieldCore]。
 *
 * 与原"自带 Pointer 监听 + 上报 LocalFloatingToolbarHost"的实现完全一致,但:
 * - 不再重复持有 11 个 mutableStateOf 状态变量、Pointer 监听、Android collapsed-cursor
 *   分支、`suppressNativeContextMenu` 等代码 —— 全部由 [RichTextTextFieldCore] 提供。
 * - 浮动工具栏由调用方(通常是 [BlockRichTextEditor] 顶层)统一渲染,本 Composable
 *   只负责把选区变化通过 [com.taocent.simple.compose.component.richtext.core.internal.toolbar.LocalFloatingToolbarHost]
 *   上报到顶层 host。
 * - `:blockrichtext` 模式:不派发 [com.taocent.simple.compose.component.richtext.core.KeyCommandRegistry]
 *   的快捷键(顶层 [BlockRichTextEditor] 拦截 Ctrl+V / 方向键做块级粘贴与表格导航)。
 */
@androidx.compose.runtime.Composable
fun RichTextTextField(
    state: com.taocent.simple.compose.component.richtext.core.RichTextState,
    modifier: Modifier = Modifier,
    placeholder: String = "请输入文本...",
    focusRequester: FocusRequester = androidx.compose.runtime.remember { FocusRequester() },
    onUserValueChange: ((old: androidx.compose.ui.text.input.TextFieldValue, new: androidx.compose.ui.text.input.TextFieldValue) -> Boolean)? = null,
    onUndo: (() -> Unit)? = null,
    onRedo: (() -> Unit)? = null,
    onTextLayout: (androidx.compose.ui.text.TextLayoutResult) -> Unit = {},
) {
    RichTextTextFieldCore(
        state = state,
        modifier = modifier,
        placeholder = placeholder,
        focusRequester = focusRequester,
        onUserValueChange = onUserValueChange,
        onUndo = onUndo,
        onRedo = onRedo,
        onTextLayout = onTextLayout,
        // :blockrichtext 模式:不派发 KeyCommand,让顶层拦截 Ctrl+V / 方向键。
        dispatchRegisteredCommands = false,
    )
}
